export default "__VITE_ASSET__CpZdFg37__"